import React from 'react';
import { connect } from 'react-redux';

const VisitInfo = (props) =>  {

    return (
        <div className="visit-info">
            <div className="info">
                <div className="text">
                    <span className="technician-type">{props.visit.technicianTypeDisplay}</span>
                    <span className="technician-date">{props.visit.displayDate}</span>
                    <span className="technician-address">{props.visit.address}</span>
                </div>
                <div className="btn-wrapper">
                    <button onClick={() => {props.onClickUpdateVisitBtn(props.visit)}}>עדכון ביקור טכנאי</button>
                    <button onClick={() => {props.onClickCancelVisitBtn(props.visit)}}>ביטול טכנאי</button>
                </div>
            </div>                    
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(VisitInfo);